import { Controller } from 'stimulus';
import getControllerForElement from '../helpers/getControllerForElement';
import toArray from '../helpers/toArray';
import validateAndSetDeliveryYears from '../helpers/validateAndSetDeliveryYear';

class PreorderRegistrationFormController extends Controller {
  connect() {
    this.toggleAddressFormRequiredState(false);
    this.handleSelectedProduct();
    this.validateAndSetDeliveryYears();
  }

  onAlreadyApplied() {
    if (this.isStepAvailable(2)) {
      // Show step 2
      this.toggleSpecificStep(2, true);
    } else {
      // Show step 3
      this.toggleSpecificStep(3, true);
    }

    // Hide the not-applied step, if it is currently visible
    this.toggleSpecificStep('not-applied', false);
  }

  onNotAlreadyApplied() {
    // Hide all steps after the 1st step
    this.toggleStepsStartingFrom(1, false);

    // Show not-applied step, telling the user that they should create a preorder first
    this.toggleSpecificStep('not-applied', true);
  }

  onSelectProduct() {
    this.toggleStepsStartingFrom(2, true);
    this.handleSelectedProduct();
    this.validateAndSetDeliveryYears();
  }

  onChangeLocation() {
    this.validateAndSetDeliveryYears();
    this.toggleSpecificStep(4, true);
  }

  validateAndSetDeliveryYears() {
    validateAndSetDeliveryYears({
      minimumYear: this.minimumYear(),
      deliverySelect: this.preferredDeliveryTarget,
    });
  }

  onToggleAddressForm(event) {
    const { checked } = event.currentTarget;

    this.addressFormTarget.style.display = checked ? 'block' : 'none';

    this.toggleAddressFormRequiredState(checked);
  }

  toggleAddressFormRequiredState(state) {
    if (!state) {
      toArray(this.addressFormTarget.querySelectorAll('[required]'))
        .forEach((requiredField) => {
          requiredField.setAttribute('data-required', 'required');
          requiredField.removeAttribute('required');
        });
    } else {
      toArray(this.addressFormTarget.querySelectorAll('[data-required]'))
        .forEach((requiredField) => {
          requiredField.setAttribute('required', 'required');
          requiredField.removeAttribute('data-required');
        });
    }
  }

  toggleStepsStartingFrom(stepIndex, state) {
    this.stepTargets.forEach((stepTarget) => {
      if (stepTarget.getAttribute('data-step') > stepIndex) {
        stepTarget.style.display = state ? 'block' : 'none';
      }
    });

    this.refreshComponents(this.element);
  }

  toggleSpecificStep(stepIndex, state) {
    this.stepTargets
      // eslint-disable-next-line eqeqeq
      .filter((stepTarget) => stepTarget.getAttribute('data-step') == stepIndex)
      .forEach((stepTarget) => {
        stepTarget.style.display = state ? 'block' : 'none';
      });

    this.refreshComponents(this.element);
  }

  isStepAvailable(stepIndex) {
    const steps = this.stepTargets
      // eslint-disable-next-line eqeqeq
      .filter((stepTarget) => stepTarget.getAttribute('data-step') == stepIndex);

    return steps.length;
  }

  minimumYear() {
    const selectedProducts = toArray(this.element.querySelectorAll('[name="product_variant_id"]:checked'));

    if (!selectedProducts.length) {
      return (new Date()).getFullYear();
    }

    return parseInt(selectedProducts[0].getAttribute('data-minimum-delivery-year'), 10);
  }

  handleSelectedProduct() {
    const selectedProducts = toArray(this.element.querySelectorAll('[name="product_variant_id"]:checked'));

    if (selectedProducts.length) {
      const maximumQuantity = parseInt(selectedProducts[0].getAttribute('data-maximum-quantity'), 10);

      const quantityField = document.getElementById('quantity');

      if (quantityField) {
        quantityField.setAttribute('max', maximumQuantity);
      }

      const flatpackDeliveryWrapper = this.element.querySelector('#flatpack_delivery_wrapper');

      const flatpackDeliverySupported = selectedProducts[0].getAttribute('data-flatpack-delivery') === 'true';

      if (flatpackDeliveryWrapper) {
        flatpackDeliveryWrapper.style.display = flatpackDeliverySupported ? 'block' : 'none';
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onQuantityBlur(event) {
    const val = parseInt(event.currentTarget.value, 10);
    const max = parseInt(event.currentTarget.getAttribute('max'), 10);

    if (Number.isNaN(val) || Number.isNaN(max)) {
      return;
    }

    if (val > max) {
      event.currentTarget.value = max;
    }
  }

  refreshComponents(element) {
    const controllersToRefresh = ['map-select'];

    controllersToRefresh.forEach((controllerToRefresh) => {
      const elements = toArray(element.querySelectorAll(`[data-controller*='${controllerToRefresh}']`));

      elements.forEach((el) => {
        getControllerForElement(this.application, el, controllerToRefresh)
          .then((controller) => {
            if (controller && typeof controller.refresh === 'function') {
              controller.refresh.call(controller);
            }
          });
      });
    });
  }
}

PreorderRegistrationFormController.targets = [
  'step',
  'preferredDelivery',
  'addressForm',
];

export default PreorderRegistrationFormController;
